export const limitString = (input, length) => {
  return input.substring(0, length);
};
